import { parseStrictJsonRecord, parseStrictJsonValue } from '@confluent/shared/lib/strict-json';

// Re-export the canonical shared output-contract parser so UI components can
// parse structured output without duplicating contract logic.
export { parseOutputContracts, buildOutputContractPromptSection } from '@confluent/shared/lib/output-contracts';
export type { ParsedOutputContract } from '@confluent/shared/lib/output-contracts';

export interface ContentSegment {
  type: 'prose' | 'json';
  content: string;
  parsed?: unknown; // For JSON segments, the parsed object
}

/**
 * Parse content into alternating prose and JSON segments.
 * Only treats the entire content as JSON when it is an exact JSON value.
 */
export function parseContentSegments(content: string): ContentSegment[] {
  const trimmed = content.trim();
  const parsed = parseStrictJsonValue(trimmed);
  if (parsed !== null) return [{ type: 'json', content: trimmed, parsed }];
  return [{ type: 'prose', content }];
}

/**
 * Extract an exact JSON object response.
 */
export function extractJsonFromResponse(content: string): Record<string, unknown> | null {
  return parseStrictJsonRecord(content);
}
